import { apiGet, apiPost, apiPut, apiDelete } from './client.js';
import type { ImportResult, MealType, Recipe, RecipeInput } from './types.js';

export function listRecipes(opts: {
  meal_type?: MealType | '';
  search?: string;
  fridge_ingredients?: number[];
} = {}): Promise<Recipe[]> {
  const params: Record<string, string> = {};
  if (opts.meal_type) params.meal_type = opts.meal_type;
  if (opts.search) params.search = opts.search;
  if (opts.fridge_ingredients && opts.fridge_ingredients.length > 0) {
    params.fridge_ingredients = opts.fridge_ingredients.join(',');
  }
  const sp = new URLSearchParams(params);
  const qs = sp.toString();
  return apiGet<Recipe[]>(`/api/recipes${qs ? `?${qs}` : ''}`);
}

export function createRecipe(body: RecipeInput): Promise<Recipe> {
  return apiPost<Recipe>('/api/recipes', body);
}

export function importRecipe(url: string): Promise<ImportResult> {
  return apiPost<ImportResult>('/api/recipes/import', { url });
}

export function updateRecipe(id: number, body: RecipeInput): Promise<Recipe> {
  return apiPut<Recipe>(`/api/recipes/${id}`, body);
}

export function deleteRecipe(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/recipes/${id}`);
}

export function getRecipe(id: number): Promise<Recipe> {
  return apiGet<Recipe>(`/api/recipes/${id}`);
}